import type { GenericObject } from './types';

const arrayCompareFunction = <T extends GenericObject, K extends keyof T>(key: K, order: 'asc' | 'desc' = 'asc') => (a: T, b: T) => {
  if (typeof key !== 'string') {
    return 0;
  }

  let varA: unknown = key.split('.').reduce((o, i) => (o)[i], a);
  if (typeof varA === 'string') varA = varA.toUpperCase();

  let varB: unknown = key.split('.').reduce((o, i) => o[i], b);
  if (typeof varB === 'string') varB = varB.toUpperCase();

  if (!varA && !varB) return 0;

  if (typeof varA === 'string' && typeof varB === 'string') {
    const stringComparison = Intl.Collator().compare(varA, varB);

    return order === 'desc' ? stringComparison * -1 : stringComparison;
  }

  if ((typeof varA === 'number' && typeof varB === 'number')) {
    let comparison = 0;

    if (!varA) comparison = -1;
    if (!varB) comparison = 1;

    if (varA > varB) comparison = 1;
    else if (varA < varB) comparison = -1;

    return order === 'desc' ? comparison * -1 : comparison;
  }

  return 0;
};

export function sortArray<T extends GenericObject[]>(array: T, key: string, order: 'asc' | 'desc' = 'asc'): T {
  return array.sort(arrayCompareFunction(key, order));
}
